import { styled } from "styled-components";

//추천
export const RecommendationForm = styled.div`
  height: 100%;
  display: flex;
  align-items: center;

  justify-content: end;
  margin-right: 20px;
`;
